<app-form>
  <app-reset-password-mail-form></app-reset-password-mail-form>
</app-form>